import React, { useEffect, useRef, useState } from 'react';
import { UserPool } from './auth-config';
import { AuthenticationDetails, CognitoAccessToken, CognitoIdToken, CognitoRefreshToken, CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';
import { Box, Button, Container, CssBaseline, FormControl, LinearProgress, Paper, SelectChangeEvent, TextField, ThemeProvider, Typography, createTheme } from '@mui/material';
import Header from './cognitoHeader';
import { Link, useNavigate } from "react-router-dom";
import ForterCaptcha from './captcha/index';
import { motion } from 'framer-motion';
import { grey } from '@mui/material/colors';
import AuthFlowSelect from './AuthFlowSelect';
import { OwnID, WidgetType } from '@ownid/react';
import { EmailInput, PasswordInput, PhoneNumberInput } from './InputFields';
import e from 'express';
import { doc } from 'prettier';
import { pocSiteDoMobileVerify } from './phoneVerification/pocSite';


const theme = createTheme();

function MobileVerify() {
    const [phone, setPhoneNumber] = useState('');
    // const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const phoneNumberField = useRef(null);
    const mdn = 'mdn';

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="lg">
                <Container maxWidth="sm">
                    <main>
                        <Paper elevation={4} sx={{
                            paddingLeft: {
                                xs: "12px",
                                md: "48px",
                            },
                            paddingRight: {
                                xs: "12px",
                                md: "48px",
                            },
                            marginTop: '50px',
                            borderRadius: '20px',
                            textAlign: 'center',
                            background: 'linear-gradient(to top, #f9f9f9, #ffffff)',
                        }}>
                            <Box display="flex" flexDirection="column" justifyContent="start" alignItems="start">
                                <h2 style={{
                                    marginBottom: '10px',
                                }}>Welcome!</h2>
                                <Typography style={{
                                    marginBottom: '40px',
                                    fontWeight: 400,
                                }} color="gray">Please enter phone number to verify.</Typography>
                            </Box>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    
                                    <FormControl fullWidth>
                                        <PhoneNumberInput ref={phoneNumberField} value={phone} id={mdn} onChange={(p) => setPhoneNumber(p.target.value)} />
                                        

                                        
                                        <Button
                                            style={{
                                                marginTop: '12px',
                                                height: "48px",
                                                backgroundColor: loading ? grey[300] : '#333333',
                                                textTransform: "none",
                                                borderRadius: "10px",
                                                color: loading ? grey[500] : 'white',
                                            }}
                                            fullWidth
                                            variant="contained"
                                            disabled={loading}
                                            // onClick={handleLogin}
                                            onClick={pocSiteDoMobileVerify}
                                        >
                                            <b>Verify</b>
                                        </Button>
                                    </FormControl>
                                    {loading && <LinearProgress sx={{
                                        width: '100%',
                                        marginTop: '24px',
                                        marginBottom: '12px',
                                        border: '1px solid #f0f0f0',
                                        backgroundColor: 'white',
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: 'gray'
                                        }
                                    }} />}
                                    <p>{message}</p>
                                </Box>
                                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                    <h2 id="statusLabel"></h2>
                                </Box>
                            </motion.div>
                        </Paper>
                    </main>
                </Container>
            </Container>
        </ThemeProvider>
    );
}

export default MobileVerify;
